import { func, shape, string } from "prop-types";
import React, { useEffect, useState, Suspense, lazy } from "react";

//Hooks
import { useSignIn } from "@overrides_venia/peregrine/talons/SignIn/useSignIn";

//Style
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import UIkit from "uikit";
import defaultClasses from "./signIn.module.scss";
import loadingPasta from "@Assets/images/loading_pasta.gif";
import signInIndicatorClasses from "../LoadingIndicator/signInIndicator.module.scss";

//Utils
import { useSignInEvent } from "@Components/SocialLogin/talons/useSignInEvent";
import { useIntl } from "react-intl";
import { isRequired } from "../../util/formValidators";

//Components
import { Form } from "informed";
import Icon from "../../../../components/Icon";
import Button from "../Button";
import FormError from "@overrides_venia/venia-ui/components/FormError";
import Password from "../Password";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";

// Utils
import { useCartContext } from "@overrides_venia/peregrine/context/cart";
import LoadingIndicator from "../LoadingIndicator";
import { isEmailValid, isPasswordValid } from "@Src_main/utils/generalUtils";
import { useCustomerCart } from "@overrides_venia/peregrine/talons/SignIn/useCustomerCart";
import { SimpleField } from "@Components/FormFields/SimpleField";
import { env } from "build/env";

// Magic Link Component
var MagicLinkLogin = lazy(() => import("@Components/MagicLink/MagicLinkLogin"));
var SignIn = _ref => {
  var {
    showCreateAccount,
    showForgotPassword,
    disablePreLogin,
    classes: propsClasses,
    onStepChange
  } = _ref;
  var classes = mergeClasses(defaultClasses, propsClasses);
  var {
    isBusy: isBusySL
  } = useSignInEvent();
  useCustomerCart();
  var {
    isMobile
  } = useWindowSize();
  var {
    ENABLE_MAGIC_LINK
  } = env;
  var [loginButtonDisable, setLoginButtonDisable] = useState(true);
  var [erroreLogin, setErroreLogin] = useState(false);
  var [isEmailOk, setIsEmailOk] = useState(false);
  var [authMethod, setAuthMethod] = useState(ENABLE_MAGIC_LINK ? "magiclink" : "password");
  var [isOtpStep, setIsOtpStep] = useState(false);
  var handleStepChange = step => {
    setIsOtpStep(step === 'otp');
    if (onStepChange) onStepChange(step);
  };
  var [{
    cartId,
    details
  }] = useCartContext();
  var {
    formatMessage
  } = useIntl();
  var {
    errors,
    handleSubmit,
    isBusy,
    setFormApi,
    handlePostSignIn
  } = useSignIn({
    showCreateAccount,
    showForgotPassword
  });
  useEffect(() => {
    var errori = Array.from(errors.values());
    errori.map((item, i) => errori[i] ? errori[i].message.includes("sign-in was incorrect or your account is disabled temporarily.") ? setErroreLogin(true) : null : null);
  }, [errors]);
  var isCheckoutPage = location.pathname.includes(formatMessage({
    id: "url.key.checkout"
  }));
  var isCartEmpty = !cartId || !details || !details.total_quantity;
  if (isBusy || isBusySL || isCheckoutPage && isCartEmpty) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.modal_active
    }, /*#__PURE__*/React.createElement(LoadingIndicator, {
      width: 200,
      heigth: 200,
      message: " ",
      global: true,
      src: loadingPasta,
      classes: {
        global: signInIndicatorClasses.global
      }
    }, formatMessage({
      id: "utils.loading"
    })));
  }
  var handleChange = event => {
    var emailValid = event.values.email && isEmailValid(event.values.email);
    var passwordValid = event.values.password;
    if (emailValid) setIsEmailOk(true);else setIsEmailOk(false);
    if (emailValid && passwordValid) {
      setLoginButtonDisable(false);
    } else {
      setLoginButtonDisable(true);
    }
  };
  var errorPass = /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-text-center ".concat(classes.infobox)
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-close",
    color: "white"
  }), formatMessage({
    id: "signin.error.password"
  }));
  function goToRegistration() {
    try {
      if (window.location.pathname.includes(formatMessage({
        id: "url.key.signup"
      }))) {
        UIkit.offcanvas("#offcanvas-login-dx").hide();
      } else {
        UIkit.offcanvas("#offcanvas-registration-dx").show();
      }
    } catch (error) {
      console.error(error);
    }
  }
  var registrationBox = /*#__PURE__*/React.createElement("div", {
    className: "uk-container uk-padding-small-top"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: goToRegistration,
    className: classes.textButton,
    style: {
      background: 'none',
      border: 'none',
      color: '#666',
      textDecoration: 'underline',
      cursor: 'pointer',
      width: '100%',
      padding: '10px',
      marginTop: '10px'
    }
  }, formatMessage({
    id: "signin.label.no.account"
  })));
  return /*#__PURE__*/React.createElement("div", {
    className: "page_wrapper"
  }, /*#__PURE__*/React.createElement(FormError, {
    errors: Array.from(errors.values()),
    id: "sign-in"
  }), ENABLE_MAGIC_LINK && !isOtpStep && /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-margin-small-bottom ".concat(classes.authMethodTabs || '')
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "uk-flex-1 uk-padding-small ".concat(authMethod === 'magiclink' ? 'uk-active' : '', " ").concat(classes.tabButton || ''),
    onClick: () => setAuthMethod("magiclink"),
    style: {
      borderBottom: authMethod === 'magiclink' ? '2px solid #000' : '1px solid #ddd',
      background: 'none',
      cursor: 'pointer',
      fontWeight: authMethod === 'magiclink' ? 'bold' : 'normal'
    }
  }, formatMessage({
    id: "login.with.email"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "uk-flex-1 uk-padding-small ".concat(authMethod === 'password' ? 'uk-active' : '', " ").concat(classes.tabButton || ''),
    onClick: () => setAuthMethod("password"),
    style: {
      borderBottom: authMethod === 'password' ? '2px solid #000' : '1px solid #ddd',
      background: 'none',
      cursor: 'pointer',
      fontWeight: authMethod === 'password' ? 'bold' : 'normal'
    }
  }, formatMessage({
    id: "signin.method.password"
  }))), authMethod === "password" && /*#__PURE__*/React.createElement(Form, {
    getApi: setFormApi,
    className: "uk-flex uk-flex-column ".concat(classes.form),
    onSubmit: handleSubmit,
    onChange: handleChange,
    autoComplete: "off"
  }, /*#__PURE__*/React.createElement(SimpleField, {
    name: "email",
    label: "input.email",
    type: "email",
    id: "emailLogin",
    required: true,
    invalid: !isEmailOk
  }), /*#__PURE__*/React.createElement(Password, {
    fieldName: "password",
    label: "input.password",
    validate: isRequired,
    autoComplete: "current-password",
    isToggleButtonHidden: false,
    errorPass: erroreLogin ? true : false,
    id: "passwordLogin",
    required: true
  }), erroreLogin && errorPass, /*#__PURE__*/React.createElement("div", {
    className: "uk-text-center uk-margin-small-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "recoverypwd",
    onClick: () => {
      try {
        UIkit.offcanvas("#offcanvas-login-dx").hide();
        UIkit.offcanvas("#offcanvas-pwdforgot-dx").show();
      } catch (error) {
        console.error(error);
      }
    }
  }, formatMessage({
    id: "signin.label.forgot.password"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "button-container_login"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "loginButton",
    color: "primary",
    fullScreen: true,
    type: "submit",
    disabled: loginButtonDisable
  }, formatMessage({
    id: "button.login"
  })))), env.ENABLE_MAGIC_LINK && authMethod === "magiclink" && /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      className: classes.modal_active
    }, /*#__PURE__*/React.createElement(LoadingIndicator, {
      width: 200,
      heigth: 200,
      message: " ",
      global: true,
      src: loadingPasta
    }, formatMessage({
      id: "utils.loading"
    })))
  }, /*#__PURE__*/React.createElement(MagicLinkLogin, {
    onSuccess: handlePostSignIn,
    onError: error => {
      console.error("Magic link error:", error);
    },
    onStepChange: handleStepChange
  })), !isBusy && !isOtpStep && registrationBox);
};
export default SignIn;
SignIn.propTypes = {
  classes: shape({
    buttonsContainer: string,
    form: string,
    forgotPasswordButton: string,
    forgotPasswordButtonContainer: string,
    root: string,
    title: string
  }),
  setDefaultUsername: func,
  showCreateAccount: func,
  showForgotPassword: func
};
SignIn.defaultProps = {
  setDefaultUsername: () => {},
  showCreateAccount: () => {},
  showForgotPassword: () => {}
};